import React, { useEffect, useRef, useState, forwardRef } from "react";
import mapboxgl from "!mapbox-gl"; // eslint-disable-line import/no-webpack-loader-syntax

import "mapbox-gl/dist/mapbox-gl.css";

const EmptyMap = forwardRef(({ defaultZoom }, ref) => {
  mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_TOKEN;
  const mapContainer = useRef(null);
  const lng = -70.9;
  const lat = 42.35;
  const [zoom, setZoom] = useState(defaultZoom ?? 3);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (ref.current) return; // initialize map only once

    ref.current = new mapboxgl.Map({
      container: mapContainer.current,
      style: "mapbox://styles/mapbox/streets-v12",
      center: [lng, lat],
      zoom: zoom,
    });

    ref.current.on("load", () => {
      ref.current.resize();
    });
  }, [lng, lat, zoom]);

  return (
    <div className="h-full relative">
      <div ref={mapContainer} className="h-full rounded-lg" />
    </div>
  );
});

export default EmptyMap;
